import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import type { PublicEventsView } from "@frontier/content/events";
import type { Profile, WorldSnapshot } from "@frontier/protocol/contracts";
import { pressHandlers } from "./press-handlers";
import { PublicEventPanel } from "./PublicEventPanel";
import "./events.css";
interface Props {
  world: WorldSnapshot;
  view: PublicEventsView;
  profile: Profile;
  connected: boolean;
  onJoin: (eventId: string) => void;
  navigationTracked?: boolean;
  expansion?: { open: boolean; onChange: (open: boolean) => void };
}
export function EventControls(props: Props) {
  const [localOpen, setLocalOpen] = useState(false);
  const open = props.expansion?.open ?? localOpen;
  const setOpen = props.expansion?.onChange ?? setLocalOpen;
  const activeCount = props.world.publicEvents.filter(
    (event) => event.status === "available" || event.status === "active",
  ).length;
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open, setOpen]);
  return (
    <div className="event-controls">
      <button
        className="events-button"
        aria-label="Публичные события"
        aria-expanded={open}
        {...pressHandlers(() => setOpen(!open))}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          aria-hidden="true"
        >
          <path d="M6 21V3m0 1h13l-4 5 4 5H6" />
        </svg>
        <small>{activeCount}</small>
      </button>
      {open &&
        createPortal(
          <PublicEventPanel {...props} onClose={() => setOpen(false)} />,
          document.body,
        )}
    </div>
  );
}
